// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-hooks-mdx": function componentSrcHooksMdx() {
    return import("./../../../src/hooks.mdx"
    /* webpackChunkName: "component---src-hooks-mdx" */
    );
  },
  "component---src-hooks-store-use-block-editor-store-mdx": function componentSrcHooksStoreUseBlockEditorStoreMdx() {
    return import("./../../../src/hooks/store/useBlockEditorStore.mdx"
    /* webpackChunkName: "component---src-hooks-store-use-block-editor-store-mdx" */
    );
  },
  "component---src-hooks-use-blocks-mdx": function componentSrcHooksUseBlocksMdx() {
    return import("./../../../src/hooks/useBlocks.mdx"
    /* webpackChunkName: "component---src-hooks-use-blocks-mdx" */
    );
  },
  "component---src-hooks-use-colors-mdx": function componentSrcHooksUseColorsMdx() {
    return import("./../../../src/hooks/useColors.mdx"
    /* webpackChunkName: "component---src-hooks-use-colors-mdx" */
    );
  },
  "component---src-hooks-use-font-sizes-mdx": function componentSrcHooksUseFontSizesMdx() {
    return import("./../../../src/hooks/useFontSizes.mdx"
    /* webpackChunkName: "component---src-hooks-use-font-sizes-mdx" */
    );
  },
  "component---src-hooks-use-post-template-mdx": function componentSrcHooksUsePostTemplateMdx() {
    return import("./../../../src/hooks/usePostTemplate.mdx"
    /* webpackChunkName: "component---src-hooks-use-post-template-mdx" */
    );
  },
  "component---src-hooks-use-post-title-mdx": function componentSrcHooksUsePostTitleMdx() {
    return import("./../../../src/hooks/usePostTitle.mdx"
    /* webpackChunkName: "component---src-hooks-use-post-title-mdx" */
    );
  },
  "component---src-hooks-use-post-type-mdx": function componentSrcHooksUsePostTypeMdx() {
    return import("./../../../src/hooks/usePostType.mdx"
    /* webpackChunkName: "component---src-hooks-use-post-type-mdx" */
    );
  },
  "component---src-hooks-use-selection-mdx": function componentSrcHooksUseSelectionMdx() {
    return import("./../../../src/hooks/useSelection.mdx"
    /* webpackChunkName: "component---src-hooks-use-selection-mdx" */
    );
  },
  "component---src-hooks-use-settings-mdx": function componentSrcHooksUseSettingsMdx() {
    return import("./../../../src/hooks/useSettings.mdx"
    /* webpackChunkName: "component---src-hooks-use-settings-mdx" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  }
};